import React from "react";
import { companyValues } from "../data/mockData";
import "./About.css";

const About = () => {
  return (
    <div className="about-page">
      <section className="section-padding">
        <div className="container">
          <div className="page-header">
            <h1 className="hero-medium">About Us</h1>
            <p className="body-large">
              Harvest Holdings builds and owns software companies that solve
              specific problems for specific people. We're operators, not
              investors — and everything we ship reflects that.
            </p>
          </div>

          <div className="about-content">
            <div className="philosophy-section">
              <h2 className="heading-2">Our Philosophy</h2>
              <p className="body-large">
                We build and own software companies that solve specific problems
                for specific people. No moonshots. Just tools that make daily life
                easier, priced fairly, and built to last.
              </p>
            </div>

            <div className="values-section">
              <h2 className="heading-2">Core Values</h2>
              <div className="values-list">
                {companyValues.map((value, index) => (
                  <div key={index} className="value-item">
                    <h3 className="heading-3">{value.title}</h3>
                    <p className="body-regular">{value.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="experience-section">
              <h2 className="heading-2">Experience</h2>
              <p className="body-regular">
                Our team's experience spans multiple disciplines and industries:
              </p>

              <div className="experience-grid">
                <div className="experience-item">
                  <h4 className="heading-3">Product Development & Innovation</h4>
                  <p className="body-small">
                    Proven track record in bringing concepts from idea to market,
                    merging technical expertise with user-centric execution.
                  </p>
                </div>

                <div className="experience-item">
                  <h4 className="heading-3">M&A & Corporate Governance</h4>
                  <p className="body-small">
                    Direct involvement in structuring M&A transactions, board service,
                    and strategic advisory with expertise in governance and long-term vision.
                  </p>
                </div>

                <div className="experience-item">
                  <h4 className="heading-3">Sales & Business Development</h4>
                  <p className="body-small">
                    History of building sales strategies that drive measurable growth
                    and strategic partnerships across sectors.
                  </p>
                </div>

                <div className="experience-item">
                  <h4 className="heading-3">Fundraising & Capital Formation</h4>
                  <p className="body-small">
                    Experience in securing capital across early-stage and growth-stage
                    companies with deep investor relationships.
                  </p>
                </div>

                <div className="experience-item">
                  <h4 className="heading-3">Federal Grant & Research Leadership</h4>
                  <p className="body-small">
                    Principal investigator experience managing federal grants and
                    research initiatives, with expertise in compliance and delivery.
                  </p>
                </div>

                <div className="experience-item">
                  <h4 className="heading-3">Global Perspective</h4>
                  <p className="body-small">
                    Work across domestic and international markets with cultural
                    fluency and networks spanning industries and geographies.
                  </p>
                </div>
              </div>
            </div>

            <div className="investment-section">
              <h2 className="heading-2">Investment</h2>
              <p className="body-regular">
                We're not a fund and we're not raising. But if you're building
                something that fits our philosophy — real problems, fair pricing,
                long-term ownership — we're open to conversations.
              </p>
              <ul className="investment-criteria">
                <li className="body-regular">Early-stage software companies ($5K - $50K range)</li>
                <li className="body-regular">Solving a clear, specific problem for a defined audience</li>
                <li className="body-regular">Sustainable business model — not dependent on VC funding</li>
                <li className="body-regular">Founder-led with a bias toward shipping</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
